import { create } from "zustand";
import { OfflineAsesmenStore } from "./offline-asesmen";
import { request } from "../../api/config";

export const useOfflineAsesmenStore = create<OfflineAsesmenStore>((set) => ({
  offlineAssessments: null,
  offlineAssessment: null,
  participants: null,
  participant: null,
  locations: null,
  ownLocation: null,

  loadingOfflineAssessments: false,
  loadingOfflineAssessment: false,
  loadingParticipants: false,
  loadingParticipant: false,
  loadingLocations: false,
  loadingOwnLocation: false,

  getOfflineAssessments: async (params?: any) => {
    set({ loadingOfflineAssessments: true });
    try {
      const { data } = await request.get("/offline-assessment", { params });
      set({ offlineAssessments: data.data });
    } catch (error) {
    } finally {
      set({ loadingOfflineAssessments: false });
    }
  },
  getOfflineAssessment: async (id: string) => {
    set({ loadingOfflineAssessment: true });
    try {
      const { data } = await request.get(`/offline-assessment/detail/${id}`);
      set({ offlineAssessment: data.data });
    } catch (error) {
    } finally {
      set({ loadingOfflineAssessment: false });
    }
  },
  getParticipants: async (asesmenId?: string, params?: any) => {
    set({ loadingParticipants: true });
    try {
      const { data } = await request.get(
        `/offline-assessment/detail/${asesmenId}/participants`,
        { params }
      );
      set({ participants: data.data });
    } catch (error) {
    } finally {
      set({ loadingParticipants: false });
    }
  },
  getParticipant: async (id: string) => {
    set({ loadingParticipant: true });
    try {
      const { data } = await request.get(
        `/offline-assessment/participant/${id}`
      );
      set({ participant: data.data });
    } catch (error) {
    } finally {
      set({ loadingParticipant: false });
    }
  },
  getLocations: async (params?: any) => {
    set({ loadingLocations: true });
    try {
      const { data } = await request.get(`/offline-assessment/places`, params);
      set({ locations: data.data });
    } catch (error) {
    } finally {
      set({ loadingLocations: false });
    }
  },
  getOwnLocation: async () => {
    set({ loadingOwnLocation: true });
    try {
      const { data } = await request.get(`/offline-assessment/own-region`);
      set({ ownLocation: data.data });
    } catch (error) {
    } finally {
      set({ loadingOwnLocation: false });
    }
  },
}));
